import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Button, Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import { useCreateEventAccountMutation } from '../../../graphql/mutations/createEventAccount.generated';
import { LayoutStoreInstance } from '../../../LayoutStore';
import { useHistory } from 'react-router';
import { FaArrowLeft } from 'react-icons/fa';
import {
  CheckboxLabel,
  VytalCheckboxLabelContainer,
} from '../../../pages/AdminStoreDetail/Menu/ProductItem/ProductOrderSheet/ExtraSelector/ExtraGroupEditModal/styled';
import Checkbox from '../../../components/Checkbox';
import { Routes } from '@/utils/routes';
import i18n from '@/utils/i18n';

export const CreateEventAccountPage: React.FC = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [email, setEmail] = useState('');
  const [sendOrderFulfillmentEmails, setSendOrderFulfillmentEmails] =
    useState(true);
  const [isBillable, setIsBillable] = useState(true);

  const [createEventAccount, { loading, error }] =
    useCreateEventAccountMutation();

  const history = useHistory();

  const handleAddEventAccount = async () => {
    if (!name || !email) {
      // Assuming only name and email are required
      alert(i18n.t('EventAccountEditPage:nameAndEmailRequired'));
      return;
    }
    const result = await createEventAccount({
      variables: {
        input: {
          name,
          description,
          email,
          should_send_order_fulfillment_emails: sendOrderFulfillmentEmails,
          is_billable: isBillable,
        },
      },
    });
    LayoutStoreInstance.setSuccess(
      i18n.t('EventAccountEditPage:eventAccountCreated'),
    );
    if (result.errors) {
      LayoutStoreInstance.setError(
        i18n.t('EventAccountEditPage:errorCreatingEventAccount'),
      );
    }
    if (result.data?.createEventAccount?.id) {
      history.push(
        Routes.eventAccountDetail(result.data.createEventAccount.id),
      );
    }
  };

  return (
    <div>
      <h2>{i18n.t('EventAccountEditPage:createNewEventAccount')}</h2>
      <Button className="float-end mt-2 mb-2" onClick={() => history.goBack()}>
        <FaArrowLeft /> {i18n.t('Common:back')}
      </Button>

      <Form style={{ clear: 'both' }}>
        <FormGroup>
          <Label for="accountName">{i18n.t('Common:name')}</Label>
          <Input
            type="text"
            name="name"
            id="accountName"
            placeholder={i18n.t('Common:name')}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="accountDescription">{i18n.t('Common:description')}</Label>
          <Input
            type="textarea"
            name="description"
            id="accountDescription"
            placeholder={i18n.t('Common:description')}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="accountEmail">{i18n.t('Common:email')}</Label>
          <Input
            type="email"
            name="email"
            id="accountEmail"
            placeholder={i18n.t('Common:email')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <VytalCheckboxLabelContainer>
            <Checkbox
              checked={sendOrderFulfillmentEmails}
              onClick={() =>
                setSendOrderFulfillmentEmails(!sendOrderFulfillmentEmails)
              }
            />
            <CheckboxLabel
              onClick={() =>
                setSendOrderFulfillmentEmails(!sendOrderFulfillmentEmails)
              }
            >
              {i18n.t('EventAccountEditPage:sendHandoutReturnEmails')}
            </CheckboxLabel>
          </VytalCheckboxLabelContainer>
        </FormGroup>
        <FormGroup>
          <VytalCheckboxLabelContainer>
            <Checkbox
              checked={isBillable}
              onClick={() => setIsBillable(!isBillable)}
            />
            <CheckboxLabel onClick={() => setIsBillable(!isBillable)}>
              {i18n.t('EventAccountEditPage:isBillable')}
            </CheckboxLabel>
          </VytalCheckboxLabelContainer>
        </FormGroup>
        {error && (
          <Alert color="danger">
            {i18n.t('Common:error')}: {error.message}
          </Alert>
        )}
        <Button
          color="primary"
          onClick={handleAddEventAccount}
          disabled={loading}
        >
          {i18n.t('EventAccountEditPage:createEventAccount')}
        </Button>
      </Form>
    </div>
  );
};
